export class DateService {
  static generateDateRange(startDate: string, endDate: string): string[] {
    const dates: string[] = [];
    const start = new Date(startDate);
    const end = new Date(endDate);
    
    const current = new Date(start);
    while (current <= end) {
      dates.push(current.toISOString().split('T')[0]);
      current.setDate(current.getDate() + 1);
    }
    
    return dates;
  }

  static formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    return date.toLocaleDateString('fr-FR');
  }

  static isDateInRange(date: string, fromDate: string, toDate: string): boolean {
    const checkDate = new Date(date);
    const from = new Date(fromDate);
    const to = new Date(toDate);
    
    return checkDate >= from && checkDate <= to;
  }
}